var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 30,
    height: 30,
    rx: 15,
    stroke: "#4B57E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3 12.2996V19.0996C12.3 19.4763 12.3989 19.7988 12.5377 20.0147C12.6793 20.2349 12.8268 20.2996 12.9286 20.2996H18.0714C18.1732 20.2996 18.3207 20.2349 18.4623 20.0147C18.6011 19.7988 18.7 19.4763 18.7 19.0996V12.2996H19.5V19.0996C19.5 19.6065 19.3687 20.0841 19.1352 20.4473C18.9045 20.8062 18.5377 21.0996 18.0714 21.0996H12.9286C12.4623 21.0996 12.0955 20.8062 11.8648 20.4473C11.6313 20.0841 11.5 19.6065 11.5 19.0996V12.2996H12.3Z",
    fill: "#4B57E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 13.4996C13.7209 13.4996 13.9 13.6787 13.9 13.8996L13.9 18.6996C13.9 18.9205 13.7209 19.0996 13.5 19.0996C13.2791 19.0996 13.1 18.9205 13.1 18.6996V13.8996C13.1 13.6787 13.2791 13.4996 13.5 13.4996Z",
    fill: "#4B57E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 13.4996C15.7209 13.4996 15.9 13.6787 15.9 13.8996V18.6996C15.9 18.9205 15.7209 19.0996 15.5 19.0996C15.2791 19.0996 15.1 18.9205 15.1 18.6996L15.1 13.8996C15.1 13.6787 15.2791 13.4996 15.5 13.4996Z",
    fill: "#4B57E7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 13.4996C17.7209 13.4996 17.9 13.6787 17.9 13.8996V18.6996C17.9 18.9205 17.7209 19.0996 17.5 19.0996C17.2791 19.0996 17.1 18.9205 17.1 18.6996V13.8996C17.1 13.6787 17.2791 13.4996 17.5 13.4996Z",
    fill: "#4B57E7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9 10.6996H11.1L11.1 11.4996H19.9V10.6996ZM11.1 9.89961C10.6582 9.89961 10.3 10.2578 10.3 10.6996V11.4996C10.3 11.9414 10.6582 12.2996 11.1 12.2996H19.9C20.3418 12.2996 20.7 11.9414 20.7 11.4996V10.6996C20.7 10.2578 20.3418 9.89961 19.9 9.89961H11.1Z",
    fill: "#4B57E7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9 9.89961C13.9 9.45778 14.2582 9.09961 14.7 9.09961H16.3C16.7418 9.09961 17.1 9.45778 17.1 9.89961V10.6996H13.9V9.89961Z",
    fill: "#4B57E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteSvg);
export default __webpack_public_path__ + "static/media/deleteSvg.d2f929c15582a083dc3ce548c903fe5c.svg";
export { ForwardRef as ReactComponent };